import {ValidationModalSection} from "~/models/navigableValidations/validationSections";
import {IErrorNavOpts} from "~/models/validationError";
import {Route} from "~/enums/route";
import {RouteHelper} from "~/helpers/routeHelper";
import NavigableValidator from "~/models/navigableValidators/navigableValidator";
import {ErrorType} from "~/enums/ErrorType";
import ListViewElement from "~/models/dashboards/elements/listViewElement";
import FieldPresenceValidator from "~/models/navigableValidators/fieldPresenceValidator";
import DashboardElementValidation from "~/models/navigableValidations/dashboardElementValidation";

export default class DashboardElementListViewElementValidation extends DashboardElementValidation<ListViewElement> {
  validators = new DashboardElementValidation(this.model).validators.concat([
    new FieldPresenceValidator({
      validatorKey: 'list_view_id',
      section: ValidationModalSection.ListViews,
      type: ErrorType.mustBeConfigured,
      displayName: "List View Element",
      message: 'Please select List View...'
    }),

    new NavigableValidator({
      validatorKey: "list_views",
      section: ValidationModalSection.ListViews,
      conditional: (model: ListViewElement , validatorKey) => {
        return !!model.list_view_id
      },
      validator: (value, model: ListViewElement) => {
        return model.list_view.is_published
      },
      message: "List View is not published",
      type: ErrorType.mustBePublished,
      displayName: (key, model: ListViewElement) => {
        return model.list_view.title
      },
    })
  ]);

  errorNavOpts(validator, validatorKey: string, value?, errorType?): IErrorNavOpts{
    const opts = super.errorNavOpts(validator, validatorKey, value);
    let model = this.model as ListViewElement;
    if (validatorKey === 'list_views') {
      opts.useLocation = `${RouteHelper.path({route: Route.editListView, modelOrId: model.list_view})}`;
    } else if (validatorKey === 'list_view_id') {
      opts.path = ValidationModalSection.Layout.toLowerCase();
    }
    return opts;
  }
}